export * from "./categories-submenu";
export * from "./departments-submenu";
export * from "./programs-submenu";
export * from "./projects-submenu";
export * from "./rooms-submenu";
export * from "./room-contents-submenu";


import { CategoriesSubmenuComponent } from "./categories-submenu";
import { DepartmentsSubmenuComponent } from "./departments-submenu";
import { ProgramsSubmenuComponent } from "./programs-submenu";
import { ProjectsSubmenuComponent } from "./projects-submenu";
import { RoomContentsSubmenuComponent } from "./room-contents-submenu";
import { RoomsSubmenuComponent } from "./rooms-submenu";

export const NavItemMolecules = [
  CategoriesSubmenuComponent,
  ProgramsSubmenuComponent,
  ProjectsSubmenuComponent,
  RoomsSubmenuComponent,
  DepartmentsSubmenuComponent,
  RoomContentsSubmenuComponent
];